module.exports = __webpack_public_path__ + "img/r-42.c832da03.jpg";